<ng-container>
	<div class="sevenseg" [ngClass]="{'blinking':isBlinking()}">
		<div class="left">{{getSmallLetters()}}</div>
		<div class="right" [ngClass]="getClasses()">{{getBigLetters()}}</div>
		<div class="unit-display">
			<span class="unit" [ngClass]="getUnitClass()">{{getUnit()}}</span>
		</div>
	</div>
	
	<div *ngIf="hasScale()" class="scale"><scale [scaleValue]="getScaleValue()" [scaleElements]="getScaleElements()" [scaleType]="getScaleType()"></scale></div>
</ng-container>